import { Avatar } from "@mui/material";
import EntriliaLogo from "@entrilia/shared/images/greylogo.png";

interface Props {
  icon: string | undefined;
}

const TabularReportCellIcon = ({ icon }: Props) => {
  return (
    <Avatar
      src={icon || EntriliaLogo}
      variant="rounded"
      alt="logo"
      slotProps={{ img: { sx: { objectFit: "contain" } } }}
      sx={{ width: 24, height: 24, mr: 1 }}
    />
  );
};

export default TabularReportCellIcon;
